import { useMediaQuery, useTheme } from '@mui/material';
import { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';

import type { ChkIconProps } from './ChkIcon.types';

type SvgWrapperProps = {
  children: ReactNode;
} & ChkIconProps;

export const ChkSvgWrapper = ({
  children,
  size = 'md',
  ...attributes
}: SvgWrapperProps) => {
  const theme = useTheme();
  const iconSize = theme.iconSize[size];
  const ref = useRef<SVGSVGElement>(null);

  const isReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  useEffect(() => {
    if (isReducedMotion) {
      ref.current?.pauseAnimations();
    }
  }, [isReducedMotion]);

  return (
    <svg
      ref={ref}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
      fill="none"
      {...attributes}
    >
      {children}
    </svg>
  );
};
